"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effector_1 = require("effector");
var blackList_1 = require("./blackList");
var chat_1 = require("./chat");
var getUserId_1 = __importDefault(require("./chat/getUserId"));
var logoutLogic_1 = require("./chat/logoutLogic");
var setSession_1 = __importDefault(require("./chat/setSession"));
var setRedEndpoint_1 = __importDefault(require("./chat/setRedEndpoint"));
var getSession_1 = __importDefault(require("./chat/getSession"));
var contacts_1 = require("./contacts");
var get_1 = __importDefault(require("./contacts/get"));
var add_1 = __importDefault(require("./contacts/add"));
var changeStatus_1 = __importDefault(require("./contacts/changeStatus"));
var dialogs_1 = __importDefault(require("./contacts/dialogs"));
var enhanced_1 = __importDefault(require("./contacts/enhanced"));
var removeContacts_1 = require("./contacts/removeContacts");
var getOpponentIds_1 = __importDefault(require("./dialogs/getOpponentIds"));
var onMessageError_1 = require("./messages/onMessageError");
var QBAdapter_1 = require("./QBAdapter");
var findUsersByIds_1 = __importDefault(require("./users/findUsersByIds"));
var loadUserById_1 = __importDefault(require("./users/loadUserById"));
var getByLogin_1 = __importDefault(require("./users/getByLogin"));
var getByName_1 = __importDefault(require("./users/getByName"));
var findUsersByFilter_1 = __importDefault(require("./users/findUsersByFilter"));
var users_1 = require("./users");
var getByArea_1 = __importDefault(require("./users/getByArea"));
var searchUsersByQuery_1 = __importDefault(require("./users/searchUsersByQuery"));
var updateUserByExternalId_1 = __importDefault(require("./users/updateUserByExternalId"));
var BlackList = __importStar(require("./blackList"));
var dialogs_2 = require("./dialogs");
var getTalker_1 = __importDefault(require("./dialogs/getTalker"));
var get_2 = __importDefault(require("./dialogs/get"));
var remove_1 = __importDefault(require("./dialogs/remove"));
var leave_1 = __importDefault(require("./dialogs/leave"));
var removePermanent_1 = __importDefault(require("./dialogs/removePermanent"));
var create_1 = __importDefault(require("./dialogs/create"));
var createGroup_1 = __importDefault(require("./dialogs/createGroup"));
var editGroup_1 = __importDefault(require("./dialogs/editGroup"));
var unreadedMessages_1 = __importDefault(require("./dialogs/unreadedMessages"));
var getHistory_1 = __importDefault(require("./dialogs/getHistory"));
var getMessagesCount_1 = __importDefault(require("./dialogs/getMessagesCount"));
var enhanced_2 = __importDefault(require("./dialogs/enhanced"));
var joinGroup_1 = __importDefault(require("./dialogs/joinGroup"));
var onKickOccupant_1 = __importDefault(require("./dialogs/onKickOccupant"));
var messages_1 = require("./messages");
var sendMessage_1 = __importStar(require("./messages/sendMessage"));
var sendReadStatus_1 = __importDefault(require("./messages/sendReadStatus"));
var delete_1 = __importDefault(require("./messages/delete"));
var messagesByDialogs_1 = __importDefault(require("./messages/messagesByDialogs"));
var onMessage_1 = __importDefault(require("./messages/onMessage"));
var sessionStore_1 = require("./calls/sessionStore");
var Calls = __importStar(require("./calls"));
var getAllUserIds_1 = __importDefault(require("./users/getAllUserIds"));
var getUser_1 = __importDefault(require("./users/getUser"));
exports.default = (function () {
    var onJoinGroupReceived = effector_1.createEvent();
    var onKickOccupant = effector_1.createEvent();
    var setChatSession = setSession_1.default(chat_1.Chat$);
    var setRedEndpoint = setRedEndpoint_1.default(chat_1.Chat$);
    var getChatSession = getSession_1.default(chat_1.Chat$);
    var getDialogs = get_2.default(dialogs_2.Dialogs$);
    var getDialogTalker = getTalker_1.default(getChatSession);
    var removeDialog = remove_1.default(getDialogs, dialogs_2.Dialogs$);
    var leaveDialog = leave_1.default(getDialogs);
    var removeDialogPermanent = removePermanent_1.default(getDialogs, dialogs_2.Dialogs$, getDialogTalker);
    var createDialog = create_1.default(getDialogs, dialogs_2.Dialogs$);
    var createGroupDialog = createGroup_1.default(getDialogs, dialogs_2.Dialogs$, getDialogTalker);
    var editGroupDialog = editGroup_1.default(getDialogs);
    var unreadedMessages = unreadedMessages_1.default(dialogs_2.Dialogs$);
    var getDialogHistory = getHistory_1.default(messages_1.Messages$, messages_1.MessagesOrder$);
    var getMessagesCount = getMessagesCount_1.default();
    var joinGroup = joinGroup_1.default(dialogs_2.Dialogs$, onJoinGroupReceived, getChatSession, getDialogs);
    onKickOccupant_1.default(dialogs_2.Dialogs$, onKickOccupant, getDialogs);
    var onContactChangeStatus = effector_1.createEvent();
    var updContactsDialogs = effector_1.createEvent();
    var getContacts = get_1.default(contacts_1.Contacts$);
    var addContact = add_1.default(getContacts);
    var getUserByLogin = getByLogin_1.default();
    var getUserByName = getByName_1.default();
    var getUsersByArea = getByArea_1.default();
    var searchUsersByQuery = searchUsersByQuery_1.default();
    var updateUserByExternalId = updateUserByExternalId_1.default();
    var ContactsOnlineStatus$ = changeStatus_1.default(onContactChangeStatus);
    var DialogsEnhanced$ = enhanced_2.default(dialogs_2.Dialogs$, ContactsOnlineStatus$, getDialogTalker);
    var ContactsByDialogs$ = dialogs_1.default(dialogs_2.Dialogs$, updContactsDialogs, getDialogTalker);
    var ContactsEnchanced$ = enhanced_1.default(contacts_1.Contacts$, ContactsOnlineStatus$, ContactsByDialogs$);
    var sendMessage = effector_1.createEvent();
    var sendReadStatus = effector_1.createEvent();
    var onMessageIn = effector_1.createEvent();
    var onReadStatus = effector_1.createEvent();
    var onDeliveredStatus = effector_1.createEvent();
    var deleteMessage = effector_1.createEvent();
    var onDeleteMessageReceived = effector_1.createEvent();
    sendMessage_1.default(DialogsEnhanced$, messages_1.Messages$, messages_1.MessagesOrder$, sendMessage, getChatSession, getDialogTalker);
    sendReadStatus_1.default(messages_1.Messages$, sendReadStatus, getChatSession);
    delete_1.default(messages_1.Messages$, messages_1.MessagesOrder$, dialogs_2.Dialogs$, deleteMessage, onDeleteMessageReceived, getDialogTalker, unreadedMessages);
    var MessagesByDialogs$ = messagesByDialogs_1.default(messages_1.Messages$, messages_1.MessagesOrder$);
    var onMessageOut = onMessage_1.default(messages_1.Messages$, messages_1.MessagesOrder$, dialogs_2.Dialogs$, onMessageIn, onReadStatus, onDeliveredStatus, getDialogs, unreadedMessages, getChatSession);
    var logout = logoutLogic_1.logoutLogic(dialogs_2.Dialogs$, messages_1.Messages$, messages_1.MessagesOrder$, blackList_1.BlackList$, users_1.Users$);
    var model = {
        Chat: {
            setRedEndpoint: setRedEndpoint,
            setSession: setChatSession,
            api: {
                Chat: chat_1.Chat$,
                getUserId: getUserId_1.default,
                logout: logout,
            },
        },
        Contacts: {
            onContactChangeStatus: onContactChangeStatus,
            api: {
                add: addContact,
                get: getContacts,
                remove: removeContacts_1.removeContacts,
                All$: ContactsEnchanced$,
            },
        },
        Users: {
            activityChange: users_1.activityChange,
            api: {
                Activity$: users_1.Activity$,
                Users$: users_1.Users$,
                findUsersByFilter: findUsersByFilter_1.default,
                findUsersByIds: findUsersByIds_1.default,
                loadLastUserActivity: users_1.loadLastUserActivity,
                getByLogin: getUserByLogin,
                getByName: getUserByName,
                getByArea: getUsersByArea,
                getUser: getUser_1.default,
                getAllUserIds: getAllUserIds_1.default,
                loadUserById: loadUserById_1.default,
                searchUsersByQuery: searchUsersByQuery,
                updateUserByExternalId: updateUserByExternalId,
            },
        },
        Dialogs: {
            onJoinGroup: onJoinGroupReceived,
            onKickOccupant: onKickOccupant,
            api: {
                get: getDialogs,
                getHistory: getDialogHistory,
                loadDialogsUnreadMessages: unreadedMessages,
                remove: removeDialog,
                leave: leaveDialog,
                removePermanent: removeDialogPermanent,
                create: createDialog,
                createGroup: createGroupDialog,
                editGroup: editGroupDialog,
                getOpponentIds: getOpponentIds_1.default,
                All$: DialogsEnhanced$,
                getMessagesCount: getMessagesCount,
                joinGroup: joinGroup,
            },
        },
        Messages: {
            onMessage: onMessageIn,
            onDeleteMessage: onDeleteMessageReceived,
            onReadStatus: onReadStatus,
            onDeliveredStatus: onDeliveredStatus,
            onMessageError: onMessageError_1.onMessageError,
            api: {
                Messages$: messages_1.Messages$,
                ByDialogs$: MessagesByDialogs$,
                sendMessage: function (dialogId) { return function (payload) {
                    return sendMessage({ dialogId: dialogId, payload: payload });
                }; },
                onNewMessage: onMessageOut,
                onSendMessage: function (callback) {
                    return sendMessage_1.sendMessageToServer.done.watch(function (_a) {
                        var params = _a.params;
                        callback(params);
                    });
                },
                onMessageError: onMessageError_1.onMessageErrorOut,
                sendReadStatus: sendReadStatus,
                sendDeliveredStatus: QBAdapter_1.sendDeliveredStatus,
                deleteMessage: deleteMessage,
            },
        },
        BlackList: {
            api: {
                UserList$: BlackList.UserList$,
                BlackList$: BlackList.BlackList$,
                addUsers: BlackList.addUsers,
                removeUsers: BlackList.removeUsers,
                isUserBlocked: BlackList.isUserBlocked,
            },
        },
        Calls: {
            onWebRTCEvent: sessionStore_1.onWebRTCEvent,
            onWebRTCEventDelayed: sessionStore_1.onWebRTCEventDelayed,
            onWebRTCEventSessionClose: sessionStore_1.onWebRTCEventSessionClose,
            api: {
                initCall: Calls.initCall,
                getUserMedia: Calls.getUserMedia,
                setLogger: Calls.setLogger,
                CallSessionList$: sessionStore_1.CallSessionList$,
                stopSession: sessionStore_1.stopSession,
                rejectSession: sessionStore_1.rejectSession,
            },
        },
    };
    return model;
});
//# sourceMappingURL=init.js.map